import { InvoiceListRoutes } from './invoice-list/invoice-list.routes';

export const InvoicesRoutes = [
  {
    path: 'factures',
    children: [
      ...InvoiceListRoutes
    ]
  }
];
